import React from 'react';
import Sidebar from './Sidebar';

const DashboardLayout = ({ children, items, role }) => {
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar items={items} role={role} />
      <div className="flex-1 overflow-auto pt-16 lg:pt-0">
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;
